<h1 mat-dialog-title class="text-dark text-xl">Estrai Dati CEM</h1>
<div mat-dialog-content class="w-full">
  <mat-form-field class="w-full" appearance="fill">
    <mat-label>Data di estrazione</mat-label>
    <input matInput [matDatepicker]="picker" [formControl]="dateControl" [max]="maxDate" />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    <mat-error *ngIf="dateControl.hasError('required')">La data è obbligatoria</mat-error>
  </mat-form-field>
</div>
<div mat-dialog-actions class="flex justify-end gap-2">
  <button mat-button color="warn" (click)="onCancel()" [disabled]="loading">Annulla</button>
  <button
    mat-raised-button
    color="primary"
    (click)="onConfirm()"
    [disabled]="dateControl.invalid || loading"
  >
    <span *ngIf="!loading">Estrai</span>
    <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
  </button>
</div>
